<template>
  <Modal :style="computedWindowSize"
         :visible="visible"
         class="p-fluid"
         @close="close">
    <template v-slot:header>
      <div class="p-dialog-title">{{ $t( 'specialOrderPositionsLabel' )}}</div>
    </template>
    <div class="p-pb-4">
      <Toolbar>
        <template #start>
          <MultipleDeleteButton :label="`${$t('Delete')} ${selectedItems?.length ? `(${selectedItems?.length})`  : ''}`"
                                @click="confirmItemsMultipleDelete"
                                :disabled="dataTableIsLoading || !selectedItems?.length" />
        </template>
        <template #end>
          <div class="p-d-flex p-ai-center p-mr-2">
            <Checkbox id="request-positions-last-30-days"
                      :binary="true"
                      :disabled="dataTableIsLoading"
                      v-model="showOnlyLast30Days"
                      @change="changeLast30DaysFilter"/>
            <label for="request-positions-last-30-days" class="pointer p-p-1">
              {{ $t('Last 30 Days') }}
            </label>
          </div>
          <SearchInput :changeUrl="false"
                       ref="searchInput"
                       @search-items="getItems"
                       :disabled="dataTableIsLoading || disableSearchInput"
                       v-model="searchData"
                       @show-spinner="isLoading = true"/>
        </template>
      </Toolbar>
    </div>


    <Spinner v-if="isLoading"/>
    <DesktopDataTable :dataTableIsLoading="dataTableIsLoading"
                      v-else
                      :emptyBlockStyle="'padding: 8vh 0;'"
                      :itemsArrayIsEmpty="itemsArrayIsEmpty"
                      :sort="sort"
                      :showSearchInput="false"
                      :actionButtonsCount="actionButtonsCount"
                      @sort-items="sortItems"
                      :headers="[
                        {name: 'code', title: $t('Code'), sortable: false},
                        {name: 'name', title: $t('Name'), sortable: false},
                        {name: 'supplier', title: $t('Supplier'), sortable: false},
                        {name: 'qty', title: $t('Qty'), sortable: false},
                        // {name: 'fixed_qty', title: 'Fixed qty', sortable: true},
                        {name: 'purchase_price', title: $t('purchasePriceShortLabel'), sortable: false},
                        {name: 'purchase_price', title: $t('sellingPriceShortLabel'), sortable: false},
                        {name: 'order', sortable: false},
                        {name: 'car', title: $store.getters.isForkliftTenant ? $t('Equipment') : $t('Car'), sortable: false},
                        {name: 'state', sortable: false},
                        {name: 'created_at', title: $t('Created'), sortable: true},
                      ]">
      <template v-slot:multiselectHeader>
        <th v-show="$store.getters.isAccountantOrHigher" class="multiSelect-column-header">
          <Checkbox :disabled="allCurrentItemsAreAdded || dataTableIsLoading" :class="{ 'no-pointer':allCurrentItemsAreAdded}" @click="selectAllCheckboxOnClick" :value="0" v-model="selectAllCheckbox"/>
        </th>
      </template>
      <template v-slot:body>
        <tr v-for="(item, index) of items"
            :key="index"
            :class="{'p-highlight': isItemSelected(item.id)}">
          <td :class="{ 'new-item': isItemAdded(item.id) }" v-show="$store.getters.isAccountantOrHigher">
            <Checkbox :disabled="dataTableIsLoading || isItemAdded(item.id)" :class="{ 'no-pointer':isItemAdded(item.id)}" :value="item.id" v-model="selectedItems"/>
          </td>
          <td :class="{ 'new-item': isItemAdded(item.id) }">
            <span v-if="item.code">{{ item.code }}</span>
            <i v-else class="ti-minus"/>
          </td>
          <td :class="{ 'new-item': isItemAdded(item.id) }">
            <span>{{ item.name }}</span>
          </td>
          <td :class="{ 'new-item': isItemAdded(item.id) }">
            <span v-if="item.supplier">{{ item.supplier.company_name }}</span>
          </td>
          <td :class="{ 'new-item': isItemAdded(item.id) }">
            <div style="position:relative; left:10px">{{ +item.ordered_qty - +item.fixed_qty }}</div>
          </td>
          <td :class="{ 'new-item': isItemAdded(item.id) }">
            <span v-if="item.purchase_price">{{ formatCurrency(item.purchase_price) }}</span>
            <i v-else class="ti-minus"/>
          </td>
          <td :class="{ 'new-item': isItemAdded(item.id) }">
            <span>{{ formatCurrency(+item.qty ? (item.sum / item.qty) : 0 ) }}</span>
          </td>
          <td :class="{ 'new-item': isItemAdded(item.id) }">
<!--            <span v-if="item.order?.uid" class="p-d-flex p-ai-center">-->
<!--              <router-link :to="{ path: `/orders/${item.order.uid}` }" target="_blank" draggable="false">-->
<!--                <Button class="p-button-text p-p-1" v-tooltip.top="item.order?.number ? item.order.number : null" :class="{'highlight&#45;&#45;link':isItemSelected(item.id)}">-->
<!--                  <i class="ti-hummer"/>-->
<!--                </Button>-->
<!--              </router-link>-->
<!--            </span>-->
<!--            <i v-else class="ti-minus"/>-->
            <OpenOrderButton :position="item"/>
          </td>
          <td :class="{ 'new-item': isItemAdded(item.id) }">
            <span v-if="item.car?.uid && formatCarLabel(item.car)">
              <router-link :to="{ path: `/vehicles/${item.car.uid}` }"
                           :target="settings.openAllLinksInSameTab ? '_self' : '_blank'"
                           rel="noopener"
                           draggable="false"
                           :class="{'highlight--link':isItemSelected(item.id)}">
                <span>{{ formatCarLabel(item.car) }}</span>
              </router-link>
            </span>
            <i v-else class="ti-minus"/>
          </td>
          <td :class="{'new-item': isItemAdded(item.id) }">
            <RequestPositionStateButton v-if="item && item.type === 2"
                                        :isDisabled="true"
                                        :position="item"/>
          </td>
          <td :class="{ 'new-item': isItemAdded(item.id) }" class="table-date-line">
            <span v-if="item.created_at || item.creator">{{ formatBy(item.created_at, item.creator) }}</span>
            <i v-else class="ti-minus"/>
          </td>
          <td :class="{ 'new-item': isItemAdded(item.id) }">
            <div class="actions">
              <AddButton v-if="!isItemAdded(item.id)" @click="addPosition(item)" :disabled="dataTableIsLoading || dataTableIsLoading || isItemSelected(item.id) || disableAddPositionButton"/>
              <ReduceButton v-else @click="removePosition(item)" :disabled="dataTableIsLoading || dataTableIsLoading || isItemSelected(item.id)"/>
            </div>
          </td>
        </tr>
      </template>
    </DesktopDataTable>

    <OwnPaginator v-show="!itemsArrayIsEmpty"
                  :rows="pagination.perPage"
                  :currentPage="pagination.currentPage - 1"
                  :totalPages="pagination.pageCount"
                  :totalRecords="pagination.totalCount"
                  :rowsPerPageOptions="[5,10,25,50,100,200]"
                  :pageLinkSize="11"
                  @page="changePage"
                  @change-per-page="changePerPage"
                  :changePaginationRoute="false"/>

    <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>

    <template #footer>
      <Button :label="$t('Close')" icon="pi pi-times" class="p-button-text" @click="close"/>
    </template>
  </Modal>

  <ConfirmMultipleDeleteModal
      :showSpinner="dataIsSending"
      :visible="confirmItemsMultipleDeleteModal"
      @close="closeConfirmItemsMultipleDeleteModal"
      @delete-items="deleteMultipleItems"/>

</template>

<script>
import settings from '@/settings'
import constants from '@/constants'
import httpClient from "@/services/http.services";
import formatMixins from '@/mixins/formatMixins'
import AddButton from '@/components/DataTable/AddButton'
import ReduceButton from '@/components/DataTable/ReduceButton'
import ConfirmMultipleDeleteModal from '@/components/ConfirmMultipleDeleteModal'
import datatableMixins from '@/mixins/datatableMixins'
import httpMixins from "@/mixins/httpMixins";
import RequestPositionStateButton from "@/pages/orders/components/RequestPositionStateButton";
import OpenOrderButton from "@/components/OpenOrderButton.vue";

export default {
  mixins: [ formatMixins, datatableMixins, httpMixins ],
  components: {OpenOrderButton, AddButton, ReduceButton, ConfirmMultipleDeleteModal, RequestPositionStateButton },
  // emits: ['close', 'update-items', 'add-position', 'remove-position', 'items-loaded', 'modal-data-on-clear'],
  emits: ['close', 'add-position', 'remove-position', 'disable-add-request-position-button', 'loading-complete'],
  name: 'RequestPositionsModal',
  props: {
    visible: Boolean,
    removeRequestPositionId: [Number, null],
    supplierId: [Number, null],
  },
  provide() {
    return {
      positionMenusState: this.positionMenusState,
      openPositionMenu: this.openPositionMenu,
      closePositionMenus: this.closePositionMenus,
    }
  },
  data() {
    return {
      positionMenusState: {
        activeKey: null,
      },
      dataTableIsLoading: false,
      disableSearchInput: false,
      dataIsSending: false,
      disableAddPositionButton: false,
      confirmItemsMultipleDeleteModal: false,
      isLoading: true,
      settings,
      submitted: false,
      fieldsExpand: 'order,car,requestStateHistoryCount',
      apiLink: 'order-position/get-unfixed-requests',
      searchData: '',
      showOnlyLast30Days: true,
      sort: {
        column: 'id',
        direction: '',
      },
      items: [],
      addedItems: [],
      selectedItems: [],
      selectAllCheckbox: [],
      constants
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.closePositionMenus()
      }
    },
    removeRequestPositionId(positionId) {
      if (!positionId) return false
      const positionIndex = this.addedItems.indexOf(positionId)
      if (positionIndex !== -1) {
        this.addedItems.splice(positionIndex, 1)
      }
    },
    selectedItems() {
      this.checkAllItemsAreSelected()
      // this.createSelectedInvoicesData()
    },
    '$store.state.thirdLayerIsOpened'() {
      if (!this.$store.state.thirdLayerIsOpened) {
        if (this.confirmItemsMultipleDeleteModal) {
          this.closeConfirmItemsMultipleDeleteModal()
        }
      }
    },
  },
  methods: {
    openPositionMenu(key) {
      this.positionMenusState.activeKey = key
    },

    closePositionMenus() {
      this.positionMenusState.activeKey = null
    },
    // clearModalData(clearAddedItems = true, clearSearchingData = true) {
    //   this.selectedItems = []
    //   this.selectAllCheckbox = []
    //   this.submitted = false
    //
    //   if (clearAddedItems) this.addedItems = []
    //   if (clearSearchingData) {
    //     this.searchData = ''
    //     this.showOnlyLast30Days = true
    //     this.$refs.searchInput?.clearLastSearchingValue()
    //   }
    //
    //   this.pagination = {
    //     totalCount: null,
    //     pageCount: null,
    //     currentPage: 1,
    //     perPage: 25
    //   }
    //   this.sort = {
    //     column: 'id',
    //     direction: '',
    //   }
    //   // this.$emit('modal-data-on-clear')
    // },
    clearModalData(clearAddedItems = true, clearSearchingData = true) {
      this.selectedItems = []
      this.selectAllCheckbox = []
      this.submitted = false

      if (clearAddedItems) {
        this.addedItems = []
      }

      const perPage = clearSearchingData
          ? 25
          : (this.pagination?.perPage ?? 25)

      if (clearSearchingData) {
        this.searchData = ''
        this.showOnlyLast30Days = true
        this.$refs.searchInput?.clearLastSearchingValue()

        this.sort = {
          column: 'id',
          direction: '',
        }
      }

      this.pagination = {
        totalCount: null,
        pageCount: null,
        currentPage: 1,
        perPage,
      }
    },
    addPosition(position) {
      if (!this.supplierId) {
        this.selectedItems = []
        this.selectAllCheckbox = []
      } else if (position.supplier_id !== this.supplierId) {
        return
      }

      this.addedItems.push(position.id)
      this.$emit('add-position', position, 4)
      this.checkAllItemsAreSelected()
    },
    removePosition(position) {
      const positionIndex = this.addedItems.indexOf(position.id)
      if (positionIndex !== -1) {
        this.addedItems.splice(positionIndex, 1)
        this.$emit('remove-position', position.id)
      }
      this.checkAllItemsAreSelected()
    },
    changePage(data) {
      if (this.pagination.currentPage === data.page + 1) return false
      this.pagination.currentPage = data.page + 1
      this.getItems()
    },
    changePerPage(perPage) {
      if (this.pagination.perPage === perPage) return false
      this.pagination.perPage = perPage
      this.pagination.currentPage = 1
      this.getItems()
    },
    changeLast30DaysFilter() {
      this.pagination.currentPage = 1
      this.selectedItems = []
      this.selectAllCheckbox = []
      this.getItems(true)
    },
    async getItems(showSpinner = false) {
      if (!this.userCanGetData || this.dataTableIsLoading) return
      this.dataTableIsLoading = true

      if (showSpinner) this.isLoading = true

      const ctrl = this.setController?.('requestPositionsModal')
      try {
        const { status, data, headers } = await httpClient({
          url: this.apiLink,
          params: {
            supplierId: this.supplierId,
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.searchData,
            expand: this.fieldsExpand,
            show_only_last_30_days: +this.showOnlyLast30Days,
            // show_only_unfixed: true,
            // show_only_ordered: true,
          },
          signal: ctrl?.signal
        })

        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          const arrayIsEmpty = !data?.length

          if (arrayIsEmpty) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }
          const noItemsAtAll = arrayIsEmpty && !this.searchData && !this.showOnlyLast30Days
          this.$emit('disable-add-request-position-button', noItemsAtAll)
          this.disableSearchInput = noItemsAtAll
        } else {
          this.items = []
          this.showUnknownError()
        }
      } catch(err) {
        this.items = []
        this.showError(err)
      } finally {
        this.isLoading = false
        this.dataTableIsLoading = false
        this.checkAllItemsAreSelected()
        this.$emit('loading-complete')
        if (this._abortors?.requestPositionsModal === ctrl) {
          this._abortors.requestPositionsModal = null
        }
      }
    },
    async deleteMultipleItems() {
      this.dataIsSending = true
      try {
        const { status } = await httpClient.post('order-position/hide-requests', { ids: this.selectedItems })
        if (status === 200) {
          this.$toast.add({severity:'success', detail: this.$t('Data deleted'), life: this.settings.toastLife});
          this.searchData = ''

          this.getItems()
          this.closeConfirmItemsMultipleDeleteModal()

          this.selectedItems = []
          this.selectAllCheckbox = []
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.dataIsSending = false
      }
    },
    confirmItemsMultipleDelete() {
      this.confirmItemsMultipleDeleteModal = true
      this.$store.commit('toggleThirdLayer', true)
    },
    closeConfirmItemsMultipleDeleteModal() {
      this.itemToDelete = {}
      this.confirmItemsMultipleDeleteModal = false
      this.$store.commit('toggleThirdLayer', false)
    },
    sortItems(columnName) { //Dont delete
      if (this.sort.column !== columnName) {
        this.sort.direction = ''
      } else {
        this.sort.direction = this.sort.direction === '' ? '-' : '';
      }
      this.sort.column = columnName
      this.getItems()
    },
    close() {
      this.$emit('close')
    }
  },
  computed: {
    actionButtonsCount() {
      return 1
    },
    computedWindowSize() {
      if (this.$store.state.mobileLayout) {
        return {position: 'absolute', top: '15px', width: '94%', marginTop: '10px'}
      } else if (!this.$store.state.mobileLayout && this.$store.state.tabletLayout) {
        return {position: 'absolute', top: '15px', width: '90%', marginTop: '15px'}
      } else {
        return {position: 'absolute', top: '15px', width: '87%', maxWidth: '1400px'}
      }
    },
  },

}
</script>

<style scoped lang="scss">

</style>
